import { AccordionSummary } from '@mui/material';
import styled from 'styled-components';

export const RecordContainer = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 19px;
  align-self: stretch;
  border-radius: var(--Border-Radius, 8px);
  border: 1px solid var(--Stroke-stroke-primary, #dce4e8);
  background: var(--Surface-bg-surface-secondary, #fff);
  margin-bottom: 24px;
`;
export const StyledAccordionSummary = styled(AccordionSummary)`
  border: 1px solid var(--Stroke-stroke-primary, #dce4e8);
  border-radius: var(--Border-Radius, 8px);
  padding: 8px 16px;
`;

export const SideDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 19px;
  align-self: stretch;
`;
